import type { BlogCategory, BlogPost, BlogPostList } from "@/types";
import api from "./api";

export const blogService = {
  listCategories: async (): Promise<BlogCategory[]> => {
    const { data } = await api.get<BlogCategory[]>("/blog/categories");
    return data;
  },

  listPosts: async (params?: { category?: string; page?: number; size?: number }): Promise<BlogPostList> => {
    const { data } = await api.get<BlogPostList>("/blog/posts", { params });
    return data;
  },

  getPost: async (slug: string): Promise<BlogPost> => {
    const { data } = await api.get<BlogPost>(`/blog/posts/${slug}`);
    return data;
  },
};
